<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useTaskComments } from '../../model/task-comments.hook'

defineOptions({
  name: 'TaskComments',
})

const {
  placeholder,
  refComment,
} = useTaskComments()
</script>

<template>
  <div class="task-comments">
    <AppText
      name="body1-medium"
      color="slate-900"
    >
      Comments
    </AppText>
    <textarea
      v-model="refComment"
      class="task-comments__textarea"
      :placeholder="placeholder"
    />
  </div>
</template>

<style lang="scss" scoped src="./TaskComments.scss" />
